import { render, staticRenderFns } from "./ProductInfoTop.vue?vue&type=template&id=29170350&scoped=true"
import script from "./ProductInfoTop.vue?vue&type=script&lang=js"
export * from "./ProductInfoTop.vue?vue&type=script&lang=js"
import style0 from "./ProductInfoTop.vue?vue&type=style&index=0&id=29170350&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29170350",
  null
  
)

export default component.exports